import request from '@aned/request';

// 导入保存
export async function signOfflineBatch(params) {
  return request('/api/sign/offline/batch', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

export async function selectPageList(params) {
  return request('/api/cashing/rate/selectPageList', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// export async function exportData(params) {
//   return request('/api/cashing/rate/exportData', {
//     method: 'POST',
//     body: params,
//     reqType: 'json',
//     module: 'basic',
//   });
// }

export async function exportDataNew(params) {
  return request('/api/cashing/rate/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}


export async function selectPageListNew(params) {
  return request('/api/cashing/rate/selectPageListNew', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'basic',
  });
}

export async function exportWaybillInfo4CashingRate(params) {
  return request('/api/cashing/rate/exportWaybillInfo4CashingRate', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'basic',
  });
}

/**
 * 查询运单实际轨迹
 * @param {*} params 
 * @returns 
 */
export async function actualTraceInfo(params) {
  return request('/api/cash/waybill/actualTraceInfo', {
    method: 'POST',
    body: params,
    // reqType: 'json',
    // module: 'basic',
  });
}
/**
 * 查询运单规划轨迹
 * @param {*} params 
 * @returns 
 */

export async function planTraceInfo(params) {
  return request('/api/cash/waybill/planTraceInfo', {
    method: 'POST',
    body: params,
    // reqType: 'json',
    // module: 'basic',
  });
}

/**
 * 查询运单对应轨迹
 * @param {*} params 
 * @returns 
 */

export async function selectByWaybillNo(params) {
  return request('/api/cash/waybill/queryDelayInfo', {
    method: 'POST',
    body: params,
    // reqType: 'json',
    // module: 'basic',
  });
}